<template>
  <div id="app">
    <top></top>
    <router-view />
    <bottom></bottom>
    <right></right>
  </div>
</template>

<script> 
import top from './components/top.vue'
import bottom from './components/bottom.vue'
import right from './components/right.vue'
export default {
  name: 'App',
  components:{top,bottom,right},
 created(){
  
 }
}
</script>

<style>
 #app{
  position: relative;
 }
*{
  box-sizing: border-box;
}
p{
  margin: 10px;
}
body{
  background: url(./assets/img/ydpage.png) no-repeat;  
  width: 100%;
  background-attachment: fixed;
    background-size: cover;
    background-position: bottom center;
}

</style>
